module.exports = __webpack_public_path__ + "static/Pfirsich-bb1174225b71665b47cf6fb48939d352.png";